import Hero from '../components/home/Hero';
import ServicesPreview from '../components/home/ServicesPreview';
import ValueProps from '../components/home/ValueProps';
import Testimonials from '../components/home/Testimonials';
import Certifications from '../components/home/Certifications';

export default function Home() {
  return (
    <>
      <Hero />
      <ServicesPreview />
      <ValueProps />
      <Testimonials />
      <Certifications />
    </>
  );
}
